import styles from "./styles.module.scss";

export const TRANSITION_TIMEOUT = {
  exit: 500,
  enter: 1000,
  appear: 1000,
};

export const TRANSITION_CLASS_NAMES = {
  appearActive: styles.entering,
  enterActive: styles.entering,
  exitActive: styles.exiting,
};
